import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, } from '@material-ui/core';
import Apis from '../../../network/Apis';
import MatchType from '../../../model/MatchType';
import MNoLiving from '../../view/MNoLiving';

class MatchSocreRankFootball extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            promotions: null,
            teamData: null,
        };
    }

    componentDidMount() {
        this.getFootballScoreRanking();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getFootballScoreRanking = async () => {
        const { competition_id } = this.props;
        let result = await Apis.encryptionGetSeaonTableDetail(MatchType.FOOTBALL, competition_id);
        console.log('getFootballScoreRanking', result);

        let teamIds = [];
        if (result.code == 200) {
            if (result.data && result.data.tables) {
                let tables = result.data.tables;
                for (let i = 0; i < tables.length; i++) {
                    if (tables[i].rows && tables[i].rows.length > 0) {
                        for (let j = 0; j < tables[i].rows.length; j++) {
                            if (teamIds.indexOf(tables[i].rows[j].team_id) < 0) {
                                teamIds.push(tables[i].rows[j].team_id);
                            }
                        }
                    }
                }
            }
        }

        let teamData = [];
        let team = await Apis.encryptionTeam(MatchType.FOOTBALL, teamIds.length > 0 ? teamIds.join(',') : undefined);
        console.log('===========>', team);
        if (team.code == 200) {
            teamData = team.data;
        }
        this.setState({ data: result.data.tables, promotions: result.data.promotions, teamData: teamData });
    }

    _getTeam = (teamId) => {
        const { teamData } = this.state;
        if (teamData) {
            for (let i = 0; i < teamData.length; i++) {
                if (teamData[i].id == teamId) {
                    return teamData[i];
                }
            }
        }
        return null;
    }

    _getPromotions = (promotion_id) => {
        const { promotions } = this.state;
        if (promotions) {
            for (let i = 0; i < promotions.length; i++) {
                if (promotions[i].id == promotion_id) {
                    return promotions[i];
                }
            }
        }
        return null;
    }

    renderRows = (item, i) => {
        const { classes } = this.props;
        let team = this._getTeam(item.team_id);

        return (
            <TableRow key={i} style={{ flex: 1 }}>
                <TableCell align='center' className={i < 3 ? classes.tableBodyCell1 : classes.tableBodyCell} style={{ width: 35 }}>{i + 1}</TableCell>
                <TableCell align='right' className={classes.tableBodyCell} style={{ minWidth: 50, flex: 1 }}>
                    <Grid container direction='row'  >
                        <img src={team ? team.logo : ''} className={classes.icon} alt=''></img>
                        <Typography style={{ color: '#0D0D0D', fontSize: 10 }}>{team ? team.name_zh : ''}</Typography>
                    </Grid>
                </TableCell>
                <TableCell align='center' className={classes.tableBodyCell} style={{ width: 35 }}>{item.total}</TableCell>
                <TableCell align='center' className={classes.tableBodyCell} style={{ width: 50 }}>{item.won + '/' + item.loss + '/' + item.draw}</TableCell>
                <TableCell align='center' className={classes.tableBodyCell} style={{ width: 35 }}>{item.goals + '/' + item.goals_against}</TableCell>
                <TableCell align='center' className={classes.tableBodyCell} style={{ width: 35 }}>{item.points}</TableCell>
            </TableRow>
        )
    }

    renderContent(val, i) {
        const { classes } = this.props;
        let promotions = this._getPromotions(val.promotion_id);
        let color = '#FFF';
        let name_zh = '';
        let isSame = false;
        if (promotions) {
            color = promotions.color;
            name_zh = promotions.name_zh;
            if (this.last && this.last.id == promotions.id) {
                isSame = true;
            }
            this.last = promotions;
        }

        return (
            <Table key={i} style={{ width: '100%', backgroundColor: color }} aria-label="a dense table">
                {
                    !isSame && promotions && <TableHead style={{ width: '100vw' }}>
                        <TableRow style={{ flex: 1 }}>
                            <TableCell colSpan={6} align='center' className={classes.tableCell} style={{ color: '#FFF' }}>{name_zh}</TableCell>
                        </TableRow>
                    </TableHead>
                }
                <TableBody style={{ width: '100vw' }}>
                    {
                        this.renderRows(val, i)
                    }
                </TableBody>
            </Table>
        );
    }

    render() {
        const { classes } = this.props;
        const { data } = this.state;
        return (
            <Grid container direction='column'>
                <Table style={{ width: '100%' }} aria-label="a dense table">
                    <TableHead style={{ backgroundColor: '#F2F2F2', width: '100vw' }}>
                        <TableRow style={{ flex: 1 }}>
                            <TableCell align='center' className={classes.tableCell} style={{ width: 35 }}>排名</TableCell>
                            <TableCell align='center' className={classes.tableCell} style={{ minWidth: 50, flex: 1 }}>球队</TableCell>
                            <TableCell align='center' className={classes.tableCell} style={{ width: 35 }}>赛</TableCell>
                            <TableCell align='center' className={classes.tableCell} style={{ width: 50 }}>胜/平/负</TableCell>
                            <TableCell align='center' className={classes.tableCell} style={{ width: 35 }}>进/失</TableCell>
                            <TableCell align='center' className={classes.tableCell} style={{ width: 35 }}>积分</TableCell>
                        </TableRow>
                    </TableHead>
                </Table>
                {
                    data && data.length > 0 && data.map((item, i) => (
                        item.rows && item.rows.map((val, n) => (
                            this.renderContent(val, n)
                        ))
                    ))
                }
                {
                    (data == null || data.length == 0) && <Grid style={{ marginTop: '20vh' }}>
                        <MNoLiving />
                    </Grid>
                }
            </Grid>

        );
    }
}

export default withRouter(withStyles((theme) => ({
    tableCell: {
        padding: theme.spacing(0.5, 0.5, 0.5, 0.5),
        fontSize: 10,
        color: '#0d0d0d',
        borderBottom: 0,

    },
    tableBodyCell1: {
        padding: theme.spacing(1, 0.5, 1, 0.5),
        fontSize: 10,
        color: '#FC182B',
        borderBottom: 0,
    },
    tableBodyCell: {
        padding: theme.spacing(1, 0.5, 1, 0.5),
        fontSize: 10,
        color: '#0d0d0d',
        borderBottom: 0,
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchSocreRankFootball));